import React from "react";

const CardSkeleton = () => {
  return (
    <div className="bg-white rounded-[13px] border border-[#98A2B3] relative overflow-hidden col-span-1 flex flex-col animate-pulse">
      <div className="w-full h-[200px] bg-gray-300"></div>

      <div className="p-5 flex flex-col flex-grow gap-3">
        <div className="flex gap-2 flex-wrap">
          <div className="h-5 w-16 bg-gray-300 rounded-[6px]"></div>
          <div className="h-5 w-20 bg-gray-300 rounded-[6px]"></div>
          <div className="h-5 w-14 bg-gray-300 rounded-[6px]"></div>
        </div>

        <div className="mt-3">
          <div className="h-5 w-2/3 bg-gray-300 rounded"></div>
        </div>

        <div className="h-[1px] bg-gray-300 w-full"></div>

        <div className="flex items-center gap-2 mt-3">
          <div className="h-4 w-5 bg-gray-300 rounded-full"></div>
          <div className="h-4 w-24 bg-gray-300 rounded"></div>
        </div>

        <div className="mt-auto flex justify-between items-center">
          <div className="flex gap-3">
            <div className="h-4 w-12 bg-gray-300 rounded"></div>
            <div className="h-4 w-16 bg-gray-300 rounded"></div>
          </div>
          <div className="h-8 w-20 bg-gray-300 rounded-lg"></div>
        </div>
      </div>
    </div>
  );
};

export default CardSkeleton;
